import { Avatar, Dialog, DialogContent, DialogTitle, makeStyles, Typography, Box, Divider } from '@material-ui/core';
import React from 'react'
import { Link } from 'react-router-dom';
import defaultAvatars from "../../../../../assets/defaultAvatars.svg";
import { IPayoutItem } from './AdminPayoutsPage';
import { X } from 'lucide-react';

const useStyles = makeStyles({
    dialogPaper: {
        backgroundColor: "#1F1F1F",
        color: "#fff",
        borderRadius: 12,
        padding: 12,
        gap: 8,
        "& .MuiDialogTitle-root, .MuiDialogContent-root": {
            padding: 0
        },
        "& .MuiTypography-root": {
            fontSize: 16
        }
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 12,
        marginTop: 16,
    },
    field: {
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: 12,
    },
    label: {
        fontWeight: 600,
        fontSize: 14,
        color: "#FFFFFF",
    },
    value: {
        fontSize: 14,
        color: "#FFFFFFCC",
    },

    userNameLink: {
        color: "#FFD0E1",
        textDecoration: "underline",
        textDecorationColor: "#FFD0E1",
        "&:hover": {
            color: "#FE5A97",
            textDecorationColor: "#FE5A97"
        }
    }
});

type UserInfoModalProps = {
    open: boolean;
    onClose: () => void;
    data: IPayoutItem | null;
    // {
    //     username: string;
    //     id: string;
    //     method?: string;
    //     iban?: string;
    //     beneficiary?: string;
    //     account?: string;
    //     swift?: string;
    //     bankName?: string;
    //     bankCountry?: string;
    // };
};

export const DetailReceipt: React.FC<UserInfoModalProps> = ({ open, onClose, data }) => {
    const classes = useStyles();
    console.log('data', data);
    const user = data ? data.creator : null
    const { typeDestination, numberDestination } = parseDestination(data ? data.destinationMasked as string : "");

    function parseDestination(destinationMasked: string) {
        if (!destinationMasked) return { typeDestination: "", numberDestination: "" }
        const [typeDestination, ...rest] = destinationMasked.split(" ");
        return {
            typeDestination,
            numberDestination: rest.join(" "),
        };
    }

    if (!data || !user) return
    return (
        <Dialog open={open}
            onClose={onClose}
            classes={{ paper: classes.dialogPaper }}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography> User info</Typography>
                    <X onClick={onClose} />
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box display={"flex"}>
                    <Avatar
                        src={user.profileImg ?? defaultAvatars}
                        alt={user.username || "User"}
                        style={{
                            width: 60,
                            height: 60,
                            marginRight: 20
                        }}
                    >
                        {!user.profileImg &&
                            (user.firstName?.[0] ||
                                user.username?.[0] ||
                                "U")}
                    </Avatar>
                    <Box>
                        <Typography variant="body2">
                            <Link to={"/" + user.username} className={classes.userNameLink}>
                                @{user.username}
                            </Link>
                        </Typography>
                        <Typography style={{ fontSize: 14, color: "#A3A3A3", marginTop: 8 }}>ID:{user._id}</Typography>
                    </Box>
                </Box>

                <Divider style={{ backgroundColor: "#FFFFFF0D", marginTop: 8, marginBottom: 8 }} />

                <Box className={classes.grid}>
                    <div className={classes.field}>
                        <span className={classes.label}>Method</span>
                        <span className={classes.value}>{data.method || "—"}</span>
                        <span className={classes.label}>{typeDestination}</span>
                        <span className={classes.value}>{numberDestination || "—"}</span>
                    </div>
                    {/* <div className={classes.field}>
                        <span className={classes.label}>Beneficiary</span>
                        <span className={classes.value}>{user.beneficiary || "—"}</span>
                    </div>
                    <div className={classes.field}>
                        <span className={classes.label}>Account №</span>
                        <span className={classes.value}>{user.account || "—"}</span>
                    </div>
                    <div className={classes.field}>
                        <span className={classes.label}>SWIFT/BIC</span>
                        <span className={classes.value}>{user.swift || "—"}</span>
                    </div>
                    <div className={classes.field}>
                        <span className={classes.label}>Bank name</span>
                        <span className={classes.value}>{user.bankName || "—"}</span>
                    </div>
                    <div className={classes.field}>
                        <span className={classes.label}>Bank country</span>
                        <span className={classes.value}>{user.bankCountry || "—"}</span>
                    </div> */}
                </Box>
            </DialogContent>
        </Dialog>
    );
};